import { Component, OnInit, OnDestroy, ChangeDetectorRef, HostListener, ElementRef } from '@angular/core';
import { DataSharingService } from '../../../data-shering-service/data-sharing.service';
import { Subscription } from 'rxjs';
import { Router } from "@angular/router";
import { DirectionService } from '../../../../direction.service';
import { AuthService } from 'src/app/auth/auth.service';
import { UsersService } from 'src/app/super-management/user/users.service';
import { BranchesService } from 'src/app/super-management/branch/branches.service';

@Component({
  selector: 'app-navigation-from-printingtable',
  templateUrl: './navigation-from-printingtable.component.html',
  styleUrls: ['./navigation-from-printingtable.component.css']
})
export class NavigationFromPrintingTableComponent implements OnInit, OnDestroy {
  public printingService: string = '';
  public printingServices: { name: string }[] = [];
  private dataServiceSubscription: Subscription;
  isDarkMode: boolean = false;

  userId: string;
  userIsAuthenticated = false;
  private authStatusSub: Subscription;
  myPrintingServicesList: string[];
  myBranchesList: string[];
  branches: any[] = [];
  branchName: string = '';
  isLoading: boolean = false;
  realBranchesObjects: any[] = [];
  realBranchesObjectsSelected: any[] = [];
  isNavOpen: boolean = false;
  isRTL: boolean = true;

  private rolesSubscription: Subscription;
  roles: string[] = [];
  isSU: boolean = false;

  constructor(
    private dataSharingService: DataSharingService,
    private router: Router,
    private directionService: DirectionService,
    private authService: AuthService,
    private usersService: UsersService,
    private branchesService: BranchesService,
    private cd: ChangeDetectorRef,
    private eRef: ElementRef,
  ) { }

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    if (this.isNavOpen && !this.eRef.nativeElement.contains(event.target)) {
      this.isNavOpen = false;
    }
  }

  async ngOnInit() {
    this.isLoading = true;
    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    this.printingServices = this.dataSharingService.getPrintingServices();

    this.dataServiceSubscription = this.dataSharingService.getPrintingService().subscribe((value) => {
      this.printingService = value;
    });

    this.dataServiceSubscription = this.dataSharingService.getBranch().subscribe((value) => {
      this.branchName = value;
    });

    this.userId = this.authService.getUserId();
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe(isAuthenticated => {
        this.userIsAuthenticated = isAuthenticated;
        this.userId = this.authService.getUserId();
      });

    this.rolesSubscription = this.authService.roles$.subscribe(roles => {
      this.roles = roles;
      if (this.roles.includes('su')) {
        this.isSU = true;
      } else {
        this.isSU = false;
      }
      this.cd.detectChanges();
    });

    if (this.userId) {
      this.usersService.getUser(this.userId).subscribe((user) => {
        if (!user) {
          this.refreshPageThroughQr();
        }
        if (user.home_printingServices_list?.length > 0 && user.home_branches_list?.length > 0) {
          this.myPrintingServicesList = [...user.home_printingServices_list];
          this.myBranchesList = [...user.home_branches_list];
        } else {
          if (this.printingService && this.printingService !== '' && this.branchName && this.branchName !== '') {
            this.myPrintingServicesList = [this.printingService];
            this.myBranchesList = [this.branchName];
          } else {
            if (localStorage.getItem('printingService') && localStorage.getItem('printingService') !== '' &&
              localStorage.getItem('branch') && localStorage.getItem('branch') !== '') {
              this.printingService = localStorage.getItem('printingService');
              this.branchName = localStorage.getItem('branch');
              this.myPrintingServicesList = [this.printingService];
              this.myBranchesList = [this.branchName];
            } else {
              this.goHome();
            }
          }
        }
      });
      this.fetchBranchesWithRetry(3);
    } else {
      this.goHome();
    }
  }

  async fetchBranchesWithRetry(retries: number) {
    try {
      this.realBranchesObjects = await this.branchesService.getAllBranches().toPromise();
      if (this.realBranchesObjects && this.realBranchesObjects.length > 0) {
        for (let branchName of this.myBranchesList) {
          const selectedBranchIndex = this.realBranchesObjects.findIndex(
            (branch: any) => branch.name === branchName
          );
          if (selectedBranchIndex !== -1) {
            this.realBranchesObjectsSelected.push(this.realBranchesObjects[selectedBranchIndex]);
          }
        }
      }
      this.isLoading = false;
    } catch (error) {
      console.error('Error fetching and transforming branches:', error);
      if (retries > 0) {
        // console.log(`Retrying... (${3 - retries + 1})`);
        this.fetchBranchesWithRetry(retries - 1);
      } else {
        if (localStorage.getItem('printingService') && localStorage.getItem('branch')) {
          this.refreshPageThroughQr();
        } else {
          this.goHome();
        }
      }
    }
  }

  ngOnDestroy() {
    this.authStatusSub.unsubscribe();
    this.dataServiceSubscription.unsubscribe();
    if (this.rolesSubscription) {
      this.rolesSubscription.unsubscribe();
    }
  }

  async chaingePrintingServiceAndBranch(selectedService: string, selectedBranch: string) {
    this.isLoading = true;
    try {
      localStorage.setItem('lastPrintingService', selectedService);
      localStorage.setItem('lastBranch', selectedBranch);
      await this.dataSharingService.setPrintingService(selectedService);
      await this.dataSharingService.setBranch(selectedBranch);
      this.authService.updateAuthData(selectedService, selectedBranch);
      this.usersService.updateUserPlace(selectedService, selectedBranch).subscribe(response => {
        this.myPrintingServicesList = [...response.home_printingServices_list];
        this.myBranchesList = [...response.home_branches_list];
        this.closeMainNav();
        this.isLoading = false;
        this.realBranchesObjectsSelected = [];
        if (this.realBranchesObjects.length > 0) {
          for (let branchName of this.myBranchesList) {
            const selectedBranchIndex = this.realBranchesObjects.findIndex(
              (branch: any) => branch.name === branchName
            );
            this.realBranchesObjectsSelected.push(this.realBranchesObjects[selectedBranchIndex]);
          }
        }
      });
    } catch (error) {
      this.isLoading = false;
      console.error('Error changing printing service and branch:', error);
    }
  }

  refreshPageThroughQr() {
    if (localStorage.getItem('printingService') && localStorage.getItem('branch')) {
      this.router.navigate(['/qr/' + localStorage.getItem('printingService') + '/' + localStorage.getItem('branch')]);
    } else {
      this.goHome();
    }
  }

  goHome() {
    this.router.navigate(['/']);
  }

  toggleMainNav() {
    this.isNavOpen = !this.isNavOpen;
  }

  closeMainNav() {
    this.isNavOpen = false;
  }

  goToPrintingQueue() {
    const branchUnique = this.realBranchesObjectsSelected[0]?.plotter?.unique ? this.realBranchesObjectsSelected[0].plotter.unique : '';
    this.router.navigate(['/queue/' + branchUnique]);
  }

  getPrintingService(index: number) {
    if (this.myPrintingServicesList?.length > 0 && this.myPrintingServicesList[index] === 'plotter') {
      return "plotter";
    } else {
      if (this.realBranchesObjectsSelected?.length > 0 && this.realBranchesObjectsSelected[index]?.express?.isPicsPrinter) {
        return "pics";
      } else {
        return "express";
      }
    }
  }
}
